/*
 *             Copyright (c) 2016 - 2023, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
const _0x3355=['oldRevisionId','_setData','add','changes','newRevisionId'];(function(_0x22c079,_0x33553d){const _0xa19dff=function(_0x271b81){while(--_0x271b81){_0x22c079['push'](_0x22c079['shift']());}};_0xa19dff(++_0x33553d);}(_0x3355,0xf6));const _0xa19d=function(_0x22c079,_0x33553d){_0x22c079=_0x22c079-0x0;let _0xa19dff=_0x3355[_0x22c079];return _0xa19dff;};import{Collection as _0x44880c}from'ckeditor5/src/utils';export default class f{constructor(_0x4630c9,_0x3408c3){this[_0xa19d('0x3')]=_0x4630c9,this[_0xa19d('0x4')]=_0x3408c3,this[_0xa19d('0x2')]=new _0x44880c();}[_0xa19d('0x0')](_0x57daab){for(const _0x452c45 of _0x57daab[_0xa19d('0x2')])this[_0xa19d('0x2')][_0xa19d('0x1')](_0x452c45);}}